import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'dug-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Doctor’s United Group',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 18773846337,
  email: 'support@dughealth.org',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/dug/index.js